


























































































































































import {
  Component,
  Vue
} from "vue-property-decorator";
import { Prop } from "@/shared/vuepack";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import FileUpload from "vue-upload-component";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  HsabExpenseEvidenceResponse,
  HsabExpenseEvidenceShoeboxModalSource,
  HsabExpenseEvidenceShoeboxResponse,
  WexUploadStatus
} from "@/shared/types";
import _ from "lodash";
import { formatMMMDateString } from "@/shared/dateString";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";

@Component({
  components: {
    GenericLoadingSpinner,
    FileUpload
  }
})
export default class HsabExpenseEvidence extends Vue {
  expenseStore = useExpenseV2Store();
  expenseEvidenceStore = useHsabExpenseEvidenceStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  hsabExpenseEvidenceShoeboxStore = useHsabExpenseEvidenceShoeboxStore();

  stagedFiles = [];
  uploadErrors = [];
  internalFileCount = 0;

  @Prop()
  expenseId: number;

  @Prop({ default: "jpeg|jpg|gif|png|pdf|heif|heic" })
  extensionsAllowed: string;

  @Prop()
  fileCountLimit: number;

  @Prop({ default: 1024 * 1024 * 8 })
  maxFileSize: number;

  @Prop()
  isUploadEnabled: boolean;

  @Prop()
  isDeleteEnabled: boolean;

  @Prop()
  isExpenseSubmitted: boolean;

  @Prop()
  isExpenseSubmittedToHsa: boolean;

  @Prop() shoeboxModalSource: HsabExpenseEvidenceShoeboxModalSource;

  get shoeboxExpenseEvidence () {
    return this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence;
  }

  get showBrowseUploadedFilesButton () {
    return this.hsabExpenseEvidenceShoeboxStore.totalItemCount > 0 && this.isUploadEnabled;
  }

  openShoeboxModal () {
    this.hsabExpenseEvidenceShoeboxStore.isBrowsingUploadedFiles = true;
    this.hsabExpenseEvidenceShoeboxStore.openShoeboxModal(this.shoeboxModalSource);
  }

  get isExistingExpense () {
    return this.expenseId !== undefined && this.expenseId !== null && this.expenseId > 0;
  }

  get regex () {
    return new RegExp(".(" + this.extensionsAllowed + ")", "i");
  }

  get calculatedCount () {
    return this.fileCountLimit - this.fileCount - this.internalFileCount;
  }

  get fileCount () {
    return 0;
  }
  shoeBoxEvidenceTitle (file: HsabExpenseEvidenceShoeboxResponse) {
    const created = `Created: ${formatMMMDateString(file.dateCreated)}`;
    if (file.dateUploaded) {
      return `${created}, Submitted: ${formatMMMDateString(file.dateUploaded)}`;
    }
    return created;
  }
  evidenceTitle (file: HsabExpenseEvidenceResponse) {
    const created = `Created: ${formatMMMDateString(file.dateCreated)}`;
    if (file.dateUploaded) {
      return `${created}, Submitted: ${formatMMMDateString(file.dateUploaded)}`;
    }
    return created;
  }
  get isInEmptyState () {
    if (this.isExistingExpense) {
      const hasStagedFile = this.stagedFiles.length > 0;
      const evidenceLoaded = this.expenseEvidenceStore.isEvidenceForExpenseLoaded(this.expenseId);
      const existingEvidence = this.expenseEvidenceStore.getExpenseEvidenceById(this.expenseId);
      return !hasStagedFile && evidenceLoaded && existingEvidence.length === 0;
    } else {
      return this.stagedFiles.length === 0;
    }
  }

  get hasShoeboxExpenseEvidence (): boolean {
    return this.shoeboxExpenseEvidence && this.shoeboxExpenseEvidence.length > 0;
  }

  mounted () {
    // Reason:BEND-6906 WAVE tool returns an error on vue-upload-component
    // because it adds an empty label element while generating the template.
    const element = document.querySelector("div.drag-container > div > div > span > label");
    if (element) {
      element.innerHTML = "upload";
    }

    this.expenseEvidenceStore.loadEvidenceForExpense(this.expenseId);
  }

  updateFiles (files) {
    const mappedFiles = files.map(f => {
      if (f && f.file) {
        return f.file;
      } else if (f.name && f.size && f.type) {
        return f;
      }
    });
    this.$emit("change", mappedFiles);
    this.stagedFiles = mappedFiles;
    this.internalFileCount = 0;
  }

  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (this.fileCountLimit && this.calculatedCount <= 0) {
        this.uploadErrors.push("Limit is " + this.fileCountLimit + " documents.");
        return prevent();
      }
      if (!this.regex.test(newFile.name)) {
        this.uploadErrors.push(
            "Files must be in one of the following formats: " + this.extensionsAllowed.split("|").join(", ") + ".");
        return prevent();
      }
      if (newFile.size > this.maxFileSize) {
        this.uploadErrors.push("File must be smaller than " + this.maxFileSize / 1048576 + " MB.");
        return prevent();
      }
      if (newFile.size === 0) {
        this.uploadErrors.push("File must be greater than 0 MB.");
        return prevent();
      }
      this.internalFileCount += 1;
    }
  }

  clearErrors () {
    this.uploadErrors = [];
  }

  deleteNewFile (file) {
    const uploadComponent: any = this.$refs.upload;
    uploadComponent.remove(file);
  }

  deleteNewShoeboxFile (file: HsabExpenseEvidenceShoeboxResponse) {
    const store = this.hsabExpenseFormStore;
    const id = file.hsabExpenseEvidenceShoeboxId;

    store.checkedShoeboxExpenseEvidence = _.filter(this.shoeboxExpenseEvidence, x => x.hsabExpenseEvidenceShoeboxId !== id);
    store.expenseForm.hsabExpenseEvidenceShoeboxIds = _.filter(store.expenseForm.hsabExpenseEvidenceShoeboxIds, x => x !== id);
  }

  removeAttachment (evidence) {
    this.expenseEvidenceStore.deleteExpenseEvidence(this.expenseId, evidence.hsabExpenseEvidenceId);
  }

  openAttachment (evidence) {
    this.expenseEvidenceStore.OpenAttachment(this.expenseId, evidence.hsabExpenseEvidenceId);
  }

  retrySubmit (evidence) {
    this.expenseEvidenceStore.retrySubmitting(this.expenseId, evidence.hsabExpenseEvidenceId);
  }

  truncateFileName (filename) {
    const maxLength = 20;
    const postfixCharacterCount = 7;
    if (filename.length > maxLength) {
      return filename.slice(0, maxLength - (postfixCharacterCount + 3)) + "..." +
          filename.slice(filename.length - postfixCharacterCount, filename.length);
    }
    return filename;
  }

  isEvidenceInFailedState (evidence) {
    if (this.isExpenseSubmitted && !this.isExpenseSubmittedToHsa) {
      return evidence.wexUploadStatus === WexUploadStatus.Failed
        || evidence.wexUploadStatus === WexUploadStatus.Unknown;
    }
    return evidence.wexUploadStatus === WexUploadStatus.Failed;
  }

  showButtonsForEvidence (evidenceId: number) {
    return !this.expenseEvidenceStore.isEvidenceLoading(evidenceId);
  }
  receiptIsPending (evidence) {
    return evidence.wexUploadStatus === WexUploadStatus.NotUploaded;
  }
  showRetrySubmission (evidence): boolean {
    return this.isEvidenceInFailedState(evidence)
        &&  ! this.hsabExpenseFormStore.uploadReceiptNotAllowed;
  }
}
